(function () {

  'use strict';

  angular.module('GroupProperties')

    .constant('GROUPS_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-paper-tray-2',
        section: 'printQueues',
        caption: 'PrintQueues',
        selected: false,
        show: true
      },
      {
        icon: 'icon-user',
        section: 'users',
        caption: 'Users',
        selected: false,
        show: true
      },
      {
        icon: 'icon-computer',
        section: 'computers',
        caption: 'Computers',
        selected: false,
        show: true
      }
    ])

    .controller('GroupPropertiesController', function (
      $scope, $location, URLS, GroupListService, $routeParams, URL_PARAMS,
      GROUPS_PROPERTIES_TABS, EventHandlerService, currentTenant, $rootScope,
      EventServiceEvents,  toastr, $filter, TenantListService) {

      $scope.tabs = GROUPS_PROPERTIES_TABS;
      $scope.group = null;
      $scope.groupOriginal = null;
      $scope.tenant = currentTenant;

      $scope.setSection = function (section) {
        $scope.showSection = section;
        const url = $location.path();
        $location.path(url, false).search({ groupSection: section });
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.$watch(function () {
        return TenantListService?.currentTenant;
      }, function () {
        if (TenantListService?.currentTenant) {
          $scope.tenant = TenantListService.currentTenant;
          getGroup();
        }
      });

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        switch ($scope.showSection) {
          case 'setup':
            $scope.helpCaption = 'HelpGroupsPropertiesSetup';
            break;
          case 'printQueues':
            $scope.helpCaption = 'HelpGroupsPropertiesPrintQueues';
            break;
          case 'users':
            $scope.helpCaption = 'HelpGroupsPropertiesUsers';
            break;
          case 'computers':
            $scope.helpCaption = 'HelpGroupsPropertiesComputers';
            break;
        }
      });

      (function () {
        EventHandlerService.deRegisterListeners();
        if ($routeParams[URL_PARAMS.SHOW_GROUP_SECTION.ROUTE]) {
          $scope.showSection = $routeParams[URL_PARAMS.SHOW_GROUP_SECTION.ROUTE];
        } else {
          $scope.showSection = 'setup';
        }
      })();

      function getGroup() {
        const url = $scope.tenant.info._links['px:tenantGroups'].href + '/' + $routeParams[URL_PARAMS.GROUP_ID.ROUTE];
        GroupListService.getGroupByUrl(url)
          .then(function (group) {
            $scope.groupOriginal = group;
            $scope.group = angular.copy(group);
          })
          .catch(function () {
          });
      }

      let taskGroupId = null;

      $scope.setTaskId = function (data) {
        taskGroupId = data.taskId;
      };

      const deregisterGroupsSynchronizationCompleteListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.GROUPS_SYNCHRONIZATION_COMPLETE, function (event, data) {
        if (taskGroupId === data.taskGroupId) {
          if (data.status === 'COMPLETED') {
            toastr.success($filter('translate')('GroupSyncVerified'));
            getGroup();
          } else {
            toastr.error($filter('translate')('GroupSyncNotVerified'));
          }
          $rootScope.$broadcast('GROUP_SYNC_COMPLETE', { group: $scope.group });
        }
      });

      $scope.$on('$destroy', function () {
        deregisterGroupsSynchronizationCompleteListener();
      });

    });

})();
